import { usePlusFeature } from '@browsing/plus';
import { PlusBenefitType } from '@pegasus/plus';
import { useConfig } from '@browsing/config';
import { usePlusExclusive } from '@browsing/hooks';
export var usePlusExclusiveElements = function (_a) {
    var plusBenefit = _a.plusBenefit;
    var isPlusExclusiveEnabled = usePlusExclusive();
    var isPlusExclusiveArticle = (plusBenefit === null || plusBenefit === void 0 ? void 0 : plusBenefit.type) === PlusBenefitType.Exclusive;
    var shouldShowPlusExclusiveElements = isPlusExclusiveEnabled && isPlusExclusiveArticle;
    return shouldShowPlusExclusiveElements;
};
export var usePlusEarlyAccessElements = function (_a) {
    var plusBenefit = _a.plusBenefit;
    var isPlusEnabled = usePlusFeature();
    var isPlusEarlyAccessArticle = (plusBenefit === null || plusBenefit === void 0 ? void 0 : plusBenefit.type) === PlusBenefitType.EarlyAccess;
    var shouldShowPlusEarlyAccessElements = isPlusEnabled && isPlusEarlyAccessArticle;
    return shouldShowPlusEarlyAccessElements;
};
export var useEnergyLabel = function () {
    var config = useConfig();
    return config.isEnabled('gpsrEnergyLabelVisible');
};
